module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_8023.46ae3cfb.png";